import { render, staticRenderFns } from "./IntroSection.vue?vue&type=template&id=457a975e&scoped=true&"
import script from "./IntroSection.vue?vue&type=script&lang=js&"
export * from "./IntroSection.vue?vue&type=script&lang=js&"
import style0 from "./IntroSection.vue?vue&type=style&index=0&id=457a975e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457a975e",
  null
  
)

export default component.exports